<script setup>
import { useRouter } from 'vue-router';

import TheTitleSection from '@/components/Layout/Components/TheTitleSection.vue';
import VirtualAssistant from '@/components/Layout/Components/TheVirtualAssistant.vue';
import { useTitleSectionContents } from '@/composables/useTitleSectionContents.js';
import { useVirtualAssistant } from '@/composables/useVirtualAssistant.js';
import { formStore } from '@/stores/form.js';
import { voertuigStore } from '@/stores/voertuig.js';

const { specialist } = formStore();
const { foto } = voertuigStore();
const router = useRouter();
const { assistantTitle, assistantExpertise, assistantBody } = useVirtualAssistant();
const { renderedTitle, renderedBody } = useTitleSectionContents();

const vehiclePhoto = () => {
  return foto.Url !== false && typeof foto.Url !== 'undefined' ? foto.Url : null;
};
</script>

<template>
  <div class="the-form">
    <!-- The title section -->
    <TheTitleSection
      :title="renderedTitle()"
      :body="renderedBody()"
      :photo="vehiclePhoto()"
    />

    <!-- The virtual assistant -->
    <VirtualAssistant
      :name="specialist.name"
      :avatar="specialist.image_url"
      :title="assistantTitle()"
      :expertise="assistantExpertise()"
      :body="assistantBody()"
      :save-for-later="!router.currentRoute?.value.meta?.hideSaveForLater"
    />
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.the-form {
  margin-bottom: 1.7rem;
}
</style>
